module.exports = require("./fr-BF.js");